import Swiper from "swiper"

// Docs for V5 https://github.com/nolimits4web/Swiper/blob/v5/API.md

const {
    site,
    is_mobile_device,
} = window.tg;

const onboardingSwiperLS = ".onboarding-swiper-ls";

/**
 * @param {string} css_class
 */

function bind_swiper(css_class, target) {
    let next_to_load = 2;
    let enable_touch = false;

    if (window.innerWidth <= 575) {
        next_to_load = 1;
    }

    if (window.matchMedia("(any-pointer: coarse)").matches) {
        enable_touch = true;
    }


    if (css_class === '.js-swiper-activity' || css_class === '.js-swiper-vouchers'){
        new Swiper(css_class, {
            slidesPerView: "auto",
            spaceBetween: css_class === '.js-swiper-activity' ? 8 : 16,
            simulateTouch: true,
            loop: false,
            watchOverflow: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });
    } else if (css_class === '.js-swiper-sleeping-arrangements') {
        const swiperContainer = document.querySelector('.swiper-container');
        const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');

        new Swiper(css_class, {
            slidesPerView: "auto",
            spaceBetween: 16,
            simulateTouch: true,
            loop: false,
            watchOverflow: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });
    } else if (css_class === '.js-swiper-room-arrangements') {
        const swiper = new Swiper(css_class, {
            slidesPerView: is_mobile_device ? 1.2 : 3.2,
            spaceBetween: 16,
            simulateTouch: true,
            loop: false,
            watchOverflow: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });

        swiper.on('init', setEqualHeight(css_class, 'top-row'));
        swiper.on('init', setEqualHeight(css_class, 'bottom-row'));
        swiper.on('resize', setEqualHeight(css_class, 'top-row'));
        swiper.on('resize', setEqualHeight(css_class, 'bottom-row'));
        swiper.init();
    } else if (css_class === '.js-swiper-peek') {
        const navigationConfig = target === "single-review"
            ? {
                nextEl: "#js-modal .swiper-button-next",
                prevEl: "#js-modal .swiper-button-prev"
            }
            : {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            };

        new Swiper(css_class, {
            preloadImages: false,
            spaceBetween: target === "single-review" ? 8 : 16,
            loop: false,
            observer: true,
            observeParents: true,
            centeredSlides: false,
            slidesPerView: target === "single-review" ? (is_mobile_device ? 1.5 : 3.2) : 'auto',
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            grabCursor: false,
            watchSlidesProgress: true,
            passiveListeners: true,
            shortSwipes: is_mobile_device,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: next_to_load,
                loadOnTransitionStart: true
            },
            navigation: navigationConfig,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
                dynamicBullets: true,
            }
        });
    } else {
              const swiper = new Swiper(css_class, {
                   simulateTouch: enable_touch,
                   preloadImages: false,
                   loop: site !== "vy" && css_class !== onboardingSwiperLS,
                   observer: true,
                   observeParents: true,
                   spaceBetween: css_class === ".js-swiper-signup" ? 16 : 0,
                   lazy: {
                       loadPrevNext: true,
                       loadPrevNextAmount: next_to_load,
                       loadOnTransitionStart: true
                   },
                   navigation: {
                       nextEl: ".swiper-button-next",
                       prevEl: ".swiper-button-prev"
                   },
                   pagination: {
                       el: ".swiper-pagination",
                       type: "bullets",
                       clickable: true,
                       dynamicBullets:
                           css_class === onboardingSwiperLS ? false : true
                   },
                   autoplay: site !== "vy" && css_class === onboardingSwiperLS ? {delay: 3500, disableOnInteraction: true} : false,
                   init: css_class === onboardingSwiperLS ? false : true,
                   on: css_class === onboardingSwiperLS ?  {
                    init: function() {
                        if (site == 'ls') {
                                const signupButton = document.getElementById('signup-button-element');
                                const loginAnchor = document.getElementById('log-in-anchor-element');
                                const closeModalButtonMobile = document.getElementById('close-modal-button-ls');
                                const closeModalButton = document.querySelector('.close-modal');
                                const jsModal = document.getElementById('js-modal');

                                const disableAutoplayOnClick = (element) => {
                                        if (element) {
                                        element.addEventListener('click', function() {
                                            swiper.autoplay.stop();
                                        })
                                    } else return
                                }
                                    disableAutoplayOnClick(signupButton);
                                    disableAutoplayOnClick(loginAnchor);
                                    disableAutoplayOnClick(closeModalButtonMobile);
                                    disableAutoplayOnClick(closeModalButton);
                                    disableAutoplayOnClick(jsModal);
                        }
                    },
                    slideChange: function() {
                        let slideIndex = swiper.activeIndex;
                        let lsOnboarding = false;

                        const onboardingBackground = document.getElementById(
                            "background"
                        );
                        const notificationCards = document.getElementById("slide-asset-1");
                        const rewardsCard = document.getElementById("slide-asset-2");
                        const blurLayer = document.getElementById("blur-layer");
                        const slideBackgrounds = {
                            slide0: "url(https://tripco-static.imgix.net/misc/DALL%C2%B7E%202024-07-24%2009.35.54%20-%20Extend%20image%201.jpg?auto=format&compress&q=80)",
                            slide1: "url(https://tripco-static.imgix.net/misc/photo_grid_bg.jpg?auto=format&compress&q=80)",
                            slide2: "url(https://tripco-static.imgix.net/misc/slide_bg_2.jpg?blur=130&auto=format&compress&q=80)",
                            slide3: "url(https://tripco-static.imgix.net/misc/slide_bg_3.jpg?auto=format&compress&q=80&blur=130)",
                        }

                        if (site == "ls" && css_class == onboardingSwiperLS) {
                            lsOnboarding = true;
                        }

                        if(lsOnboarding && slideIndex !== 2) {
                             notificationCards.style.display = "none";
                        }

                        if (lsOnboarding && slideIndex !== 3) {
                            rewardsCard.style.display =  "none"
                            blurLayer.style.backdropFilter = "none";
                            blurLayer.style.backgroundColor = "transparent";


                        }


                        if (lsOnboarding && slideIndex === 0) {
                            onboardingBackground.style.background = slideBackgrounds[`slide${slideIndex}`];
                             onboardingBackground.style.backgroundSize = "cover";
                             onboardingBackground.style.backgroundPosition = "center";


                        }

                        if (lsOnboarding && slideIndex === 1) {
                            onboardingBackground.style.background = slideBackgrounds[`slide${slideIndex}`];
                            onboardingBackground.style.backgroundSize = "cover";

                        }
                        if (lsOnboarding && slideIndex === 2) {
                            onboardingBackground.style.background = slideBackgrounds[`slide${slideIndex}`];
                            onboardingBackground.style.backgroundSize = "cover";
                            notificationCards.style.display = "initial";


                        }
                        if (lsOnboarding && slideIndex === 3) {
                            onboardingBackground.style.background = slideBackgrounds[`slide${slideIndex}`];
                            onboardingBackground.style.backgroundSize = "cover";
                            rewardsCard.style.display = "initial";
                            blurLayer.style.backgroundColor = "rgba(37, 37, 37, 0.45)";

                        }
                    }
                   } : {},
               });

               if (site == 'ls' && css_class == onboardingSwiperLS) {
                   swiper.init();
               }
           }
}

function setEqualHeight(containerClass, cardClass) {
    const cards = document.querySelectorAll(`${containerClass} .card.${cardClass}`);
    let maxHeight = 0;

    // Reset heights to auto to get natural heights
    cards.forEach(card => {
        card.style.height = 'auto';
    });

    // Calculate the maximum height
    cards.forEach(card => {
        const cardHeight = card.offsetHeight;
        if (cardHeight > maxHeight) {
            maxHeight = cardHeight;
        }
    });

    // Set all cards to the maximum height
    cards.forEach(card => {
        card.style.height = `${maxHeight + 20}px`;
    });
}

export {bind_swiper};
